export { default } from './NewsCarousel';
